const isProduction = process.env.NEXT_PUBLIC_NENV === 'production';
const isStaging = process.env.NEXT_PUBLIC_NENV === 'staging';
const isQa = process.env.NEXT_PUBLIC_NENV === 'qa';
// Dev-only escape hatch: set NEXT_PUBLIC_AMPLITUDE_FORCE_LOAD=true in a local .env to load
// Amplitude on the devbox for testing, without switching NEXT_PUBLIC_NENV to staging/qa.
const isForceLoad = process.env.NEXT_PUBLIC_AMPLITUDE_FORCE_LOAD === 'true';
export const isOkToLoad = (isProduction || isStaging || isQa || isForceLoad);